export default __webpack_public_path__ + "static/media/gg-logo.3e4d4252.svg";